import axiosInstance from "auth/FetchInterceptor";
import {
  EXPORT_EXCEL_STORE,
  GET_MY_STORE,
  GET_PARTNER_STORE_LIST,
  STORE_API,
  STORE_UPSERT_V2,
  STORE_CHANGE_STATE,
  STORE_LIST_PARTNER_V2,
  STORE_SEARCH_GRID,
  WORKABLE_STORES,
  WORKABLE_STORES_BY_REGION,
} from "constants/ApiConstant";
const StoreService = {};

StoreService.storeSearchGrid = function (data) {
  return axiosInstance.post(STORE_SEARCH_GRID, data);
};

StoreService.getWorkableStores = function (data) {
  return axiosInstance.get(WORKABLE_STORES, data);
};

StoreService.getWorkableStoresByRegion = function (data) {
  return axiosInstance.get(WORKABLE_STORES_BY_REGION, data);
};

StoreService.getMyStore = function (data) {
  return axiosInstance.get(GET_MY_STORE, data);
};
StoreService.getStoreById = function (id) {
  return axiosInstance.get(`${STORE_API}/${id}`, null);
};
StoreService.createStore = function (data) {
  return axiosInstance.post(STORE_API, data);
};
StoreService.updateStore = function (data) {
  return axiosInstance.put(STORE_API, data);
};
StoreService.createStoreV2 = function (data) {
  return axiosInstance.post(STORE_UPSERT_V2, data);
};
StoreService.updateStoreV2 = function (data) {
  return axiosInstance.put(STORE_UPSERT_V2, data);
};
StoreService.updateStoreState = function (data) {
  return axiosInstance.put(STORE_CHANGE_STATE, data);
};
StoreService.delStore = function ({ id, password }) {
  return axiosInstance.delete(`${STORE_API}/delete-v2`, {
    params: { id, password },
  });
};

StoreService.getStoreUnit = function (id) {
  return axiosInstance.get(`${STORE_API}/store-unit/${id}`, null);
};

StoreService.upSetStoreUnit = function (data) {
  return axiosInstance.post(`${STORE_API}/store-unit`, data);
};

StoreService.getPartnerStoreList = function (payload) {
  return axiosInstance.get(
    `${GET_PARTNER_STORE_LIST}/${payload.partnerId}`,
    null,
  );
};

StoreService.getStoreListPartnerV2 = function (data) {
  return axiosInstance.post(STORE_LIST_PARTNER_V2, data);
};

StoreService.exportExcel = function (params) {
  return axiosInstance.post(EXPORT_EXCEL_STORE, params, {
    responseType: "blob",
  });
};

export default StoreService;
